<template>
  <div class="user-photo-wrapper">
    <BaseImage
      :error-messages="errorMessages"
      :src="user.photo"
      alt="photo"
      class="user-photo"
      rounded
      width="220"></BaseImage>
    <v-btn
      v-show="!readonly"
      :disabled="$loading.isLoading(`getFile_${modelValue}`)"
      class="user-photo-edit"
      color="white"
      icon
      rounded="circle"
      size="x-small"
      variant="elevated"
      @click="openSelectPhotoDialog">
      <v-icon color="black">mdi-light:camera</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { openDialog } from '@/dialog/index.ts'

export default {
  name: 'UserPhoto',
  emits: ['update:model-value'],
  props: {
    modelValue: { type: [Object, String, Number] },
    user: { type: Object },
    v$: { type: Object },
    readonly: {
      type: Boolean,
    },
    errorMessages: {
      type: Array,
    },
  },
  setup(props, { emit }) {
    const openSelectPhotoDialog = () => {
      openDialog({
        name: 'UserPhoto',
        dialogData: { user: props.user },
        params: {
          hideActionButtons: true,
          cb: photo => {
            emit('update:model-value', photo)
          },
        },
      })
    }

    return {
      openSelectPhotoDialog,
    }
  },
}
</script>

<style lang="scss">
.user-photo {
  &-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 220px;
    height: 220px;
    position: relative;
  }

  &-edit {
    position: absolute;
    bottom: 5px;
    right: 5px;
  }
}
</style>
